<template>
  <div class="about-us-arrow-2" :class="{primary: isPrimary, hidden: isHidden}">
    <div class="main-box">
      <div class="heading-3-bold">{{title}}</div>
      <div class="thin-arrow-holder">
        <div class="branch"></div>
        <div class="branch"></div>
      </div>
      <div class="thin-arrow-holder second">
        <div class="branch"></div>
        <div class="branch"></div>
      </div>
    </div>
      <div class="arrow"></div>
<!--    <div class="arrow-container">-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'AboutUsArrow2',
  props: {
    isPrimary: Boolean,
    title: String,
    isHidden: Boolean
  }
}
</script>

<style lang="scss">
@import "AboutUsArrow2.scss";
</style>
